import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core';
import * as CartStore from '../../../../store/cart';
import { GaService, OrderService, ProductService } from 'src/app/services';
import { takeWhile } from 'rxjs/operators';
import * as SelectProductStore from '../../../../store/select-product';
import { SelectBulkProductComponent } from 'src/app/modules/pc/_component/select-bulk-product/select-bulk-product.component';

@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  providers: [SelectBulkProductComponent],
})
export class AddToCartComponent extends BaseComponent implements OnInit {
  constructor(public productService: ProductService, private selectBulkProduct: SelectBulkProductComponent) {
    super();
  }
  ngOnInit() {}

  onAddToCart() {
    // window.alert(`${this.productService.selectProducts.length}건 카트에 담기 아직 API 개발전`);
    if (this.productService.selectProducts.length !== 0) this.productService.emitCloseModal();
  }

  reset() {
    this.productService.selectProducts = [];
    this.productService.emitResetProduct();
  }
}
